import CustomizedToast from 'component/Custom/CustomizedToast/CustomizedToast';
import React, { useState, useMemo, createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

const ToastContext = createContext();

function generateUEID() {
  let first = (Math.random() * 46656) | 0;
  let second = (Math.random() * 46656) | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);

  return first + second;
}

export const ToastProvider = (props) => {
  const [toasts, setToasts] = useState([]);
  const [currentToast, setCurrentToast] = useState(null);

  const open = (content, toastType) => {
    setToasts((prevQueue) => [
      ...prevQueue,
      { id: generateUEID(), content, toastType },
    ]);

    if (!currentToast) {
      setTimeout(showNextToast, 100);
    }
  };
  const close = () => {
    setCurrentToast(null);
    setTimeout(() => {
      if (toasts.length > 0) {
        showNextToast();
      }
    }, 3000);
  };

  const showNextToast = () => {
    setToasts((prevQueue) => {
      if (prevQueue.length === 0) return prevQueue;

      const nextToast = prevQueue[0];
      setCurrentToast(nextToast);

      return prevQueue.slice(1);
    });
  };

  const contextValue = useMemo(() => ({ open }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      {props.children}

      {createPortal(
        <div className="toasts-wrapper">
          {currentToast && (
            <CustomizedToast
              key={currentToast.id}
              close={close}
              text={currentToast.content}
              toastType={currentToast.toastType}
            />
          )}
        </div>,
        document.body
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
